import { MainContent } from '@/components/content'
import { MainLayout } from '@/components/layouts'
import { SettingSidebar } from '@/components/sidebar'
import { ProviderRevenueCat } from '@/pages/external/ExternalPremiumLogin/RevenueCatProvider'
import { RevenueCatPurchase } from '@/pages/external/RevenuecatCheckout'

export function SubscriptionPage() {
  return (
    <MainLayout>
      <SettingSidebar />
      <MainContent>
        <div className="flex w-full flex-col items-center">
          <div
            className={`flex flex-col w-full lg:w-[480px] gap-y-4 ml-0 transition-all duration-500 ease-in-out mb-20 lg:mb-8`}
          >
            <ProviderRevenueCat>
              <RevenueCatPurchase />
            </ProviderRevenueCat>
          </div>
        </div>
      </MainContent>
    </MainLayout>
  )
}
